/* eslint-disable camelcase */
import { Modal, Tabs } from 'antd'
import React, { useState } from 'react'
import { getCookie } from '../../../../guard/route'
import jwt_decode from 'jwt-decode'
import SelectedDataRelatedProblem from './SelectedDataRelatedProblem'
import SelectRelateDataTableProblems from './SelectRelateDataTableProblems'

interface Param {
    ticketTypeIsRequest?: boolean
    isShowOnlyTabKM: boolean
    // isProblemClosed?: boolean
}

type Props = Param

const { TabPane } = Tabs
const { confirm } = Modal
const RelatedProblemHome: React.FC<Props> = (props: Props) => {
    const [isModalVissible, setIsModalVisible] = useState<boolean>(false)
    const [tabpaneSelectName, setTabpaneSelectName] = useState<string>('Ticket')
    const [isCancelModal, setIsCancelModal] = useState<boolean>(false)
    const decoded: any = jwt_decode(getCookie('access_token') || '')
    const isTabShowTabTicket = window.location.pathname.includes('/IncidentDetailsView')

    const ButtonSelectdata = (tabpane: string) => {
        return (
            <div style={{ textAlign: 'end' }}>
                <span className="feck-link" onClick={() => { showModal(tabpane) }} style={{fontSize: '16px', fontWeight: 'bold'}}>Select {tabpane}</span>
            </div>
        )
    }

    const showModal = (value: string) => {
        setIsModalVisible(true)
        setTabpaneSelectName(value)
    }

    const closeModal = () => {
        confirm({
            title: <b style={{ color: '#323276', fontSize: '25px', fontWeight: 'bold' }}>Are you sure?</b>,
            content: <span style={{ color: '#5A5A89', fontSize: '16px' }}>You want to leave this page?</span>,
            okText: 'Yes',
            cancelText: 'No',
            okType: 'danger',
            autoFocusButton: 'cancel',
            className: 'custom-modal-wo',
            onOk() {
                setIsModalVisible(false)
                setIsCancelModal(true)
            },
            onCancel() {
                console.log('Cancel')
            }
        })
    }

    return (
        <div>
            {props.isShowOnlyTabKM ? <Tabs defaultActiveKey="2" type="card">
                <TabPane tab="Knowledge" key="2" disabled={!decoded.service.serviceId.includes(5)}>
                    {ButtonSelectdata('Knowledge')}
                    <br />
                    <SelectedDataRelatedProblem tabpaneName={'Knowledge'} isShowOnlyTabKM={props.isShowOnlyTabKM}/>
                </TabPane>
            </Tabs> : <Tabs defaultActiveKey="1" type="card">
                <TabPane tab="Asset" key="1" disabled={!decoded.service.serviceId.includes(2)}>
                    {ButtonSelectdata('Asset')}
                    <br />
                    <SelectedDataRelatedProblem tabpaneName={'Asset'} />
                </TabPane>
                <TabPane tab="Knowledge" key="2" disabled={!decoded.service.serviceId.includes(5)}>
                    {ButtonSelectdata('Knowledge')}
                    <br />
                    <SelectedDataRelatedProblem tabpaneName={'Knowledge'} />
                </TabPane>
                {isTabShowTabTicket === false ? <TabPane tab="Ticket" key="3" disabled={!decoded.service.serviceId.includes(1)}>
                    {ButtonSelectdata('Ticket')}
                    <br />
                    <SelectedDataRelatedProblem tabpaneName={'Ticket'} />
                </TabPane> : null}
            </Tabs>}
            <Modal
                title={tabpaneSelectName === 'Workflow' ? tabpaneSelectName : tabpaneSelectName + ' List'}
                visible={isModalVissible}
                onCancel={() => closeModal()}
                closable={true}
                footer={null}
                width={'90%'}
            >
                <SelectRelateDataTableProblems modalVisisle={isModalVissible} setModalvisible={setIsModalVisible} tabpaneName={tabpaneSelectName} isCancelModal={isCancelModal} setIsCancelModal={setIsCancelModal} />
            </Modal>
        </div>
    )
}

export default RelatedProblemHome
